import { DEFAULT_LIMIT } from '@trip-ux/constants';
import {
  POLICY_SEARCH,
  POLICY_SEARCH_SUCCESS,
  POLICY_SEARCH_FAILED,
  PolicySearchList,
  PolicySearchGridSort,
  PolicySearchResponse,
  PolicySearchData,
  POLICY_SORT,
  PLAN_NAME,
  POLICY_SEARCH_RESET
} from './types';
type PolicySearchActionPayload =
  | PolicySearchGridSort
  | PolicySearchResponse
  | PolicySearchData
  | Record<string, string>;
export const policySearch = (
  state: PolicySearchList = {
    searchFetched: false,
    pageNumber: 0,
    loading: false
  },
  action: {
    type: string;
    payload?: PolicySearchActionPayload;
  }
): PolicySearchList => {
  switch (action.type) {
    case POLICY_SEARCH:
      const searchCriteria = action.payload as PolicySearchData;
      return {
        ...state,
        loading: true,
        searchFetched: false,
        searchCriteria,
        pageNumber: searchCriteria.offset / DEFAULT_LIMIT + 1
      };
    case POLICY_SEARCH_SUCCESS: {
      const payload = action.payload as PolicySearchResponse;
      return {
        ...state,
        loading: false,
        searchFetched: true,
        data: payload,
        searchError: undefined
      };
    }
    case POLICY_SEARCH_RESET:
      return {
        ...state,
        loading: false,
        data: undefined,
        searchError: undefined
      };

    case POLICY_SEARCH_FAILED:
      return { ...state, loading: false, searchFetched: true, searchError: action.payload, data: undefined };
    case POLICY_SORT:
      return { ...state, sort: action.payload as PolicySearchGridSort };
    case PLAN_NAME:
      return { ...state, planNames: action.payload as Record<string, string> };
    default:
      return state;
  }
};
